import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import airBnbLogo from './images/airbnb.png';
import vrboLogo from './images/vrbo.png';
import homeawayLogo from './images/homeaway.png';
import phoneImage from './images/iphone.png';

import css from './FAQSectionPlatforms.module.css';
import { Container } from '../../components/Layout';

const FAQSectionPlatforms = () => {
  return (
    <div className={css.root}>
      <Container>
        <div className={css.wrapper}>
          <div className={classNames(css.column, css.contentColumn)}>
            <div className={css.platformLogos}>
              <img
                src={airBnbLogo}
                alt=""
                className={classNames(css.platformLogo, css.platformAirBnB)}
              />
              <img
                src={vrboLogo}
                alt=""
                className={classNames(css.platformLogo, css.platformVrbo)}
              />
              <img
                src={homeawayLogo}
                alt=""
                className={classNames(css.platformLogo, css.platformHomeAway)}
              />
            </div>

            <div>
              <h1 className={css.title}>
                <FormattedMessage id="FAQLandownersPage.platformsTitle" />
              </h1>

              <p className={css.content}>
                <FormattedMessage id="FAQLandownersPage.platformsContent" />
              </p>
            </div>
          </div>

          <div className={classNames(css.column, css.phoneColumn)}>
            <img src={phoneImage} alt="" className={css.phoneImage} />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default FAQSectionPlatforms;
